import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';
import Raven from 'raven-js'; // Or, you might already have this as `window.Raven`.
import createRavenMiddleware from 'raven-for-redux';
import { makeRootReducer } from './reducers';
import createHelpers from './createHelpers';
import createLogger from './logger';

Raven.config('https://ff50ca238f8047a681fcca5d61818291@sentry.io/1248362').install();

export default function configureStore(initialState, helpersConfig) {
  const helpers = createHelpers(helpersConfig);
  const middleware = [
    routerMiddleware(browserHistory),
    thunk.withExtraArgument(helpers),
    createRavenMiddleware(Raven, {
      // Optionally pass some options here.
    }),
  ];

  let enhancer;

  if (__DEV__) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    let devToolsExtension = f => f;
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware(...middleware), devToolsExtension);
  } else {
    enhancer = applyMiddleware(...middleware);
  }

  const store = createStore(makeRootReducer(), initialState, enhancer);
  store.asyncReducers = {};

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('../reducers', () =>
      // eslint-disable-next-line global-require
      store.replaceReducer(require('../reducers').default)
    );
  }

  return store;
}



// WEBPACK FOOTER //
// src/store/configureStore.js